/** A document that may carry an archive stamp — a requisition, order, goods receipt or invoice. */
export interface ArchivableDocument {
  readonly archivedAt?: unknown;
}

/** Whether the document was archived; an archived document is read-only until unarchived. */
export const isDocumentArchived = (document: ArchivableDocument): boolean =>
  document.archivedAt != null;

/** A requisition, order or invoice as the archive gate reads it. */
export interface ArchiveGateDocument {
  readonly cancelledAt?: unknown;
  readonly isCompleted?: boolean | null;
}

/** Only a completed document may be filed away; a cancelled one is already read-only. */
export const isDocumentArchivable = (document: ArchiveGateDocument): boolean =>
  document.cancelledAt == null && document.isCompleted === true;
